export default "__VITE_ASSET__a2b615a8__"